import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {AuthIsSignedIn} from '../context/AuthContext';


const PrivateRoute = () => {
  const isLoggedIn = useSelector((state) => state.auth.authentication); 
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;